module.exports = __webpack_public_path__ + "static/vector-shape2-0d81d5ff840eb9b211286a9f0dd5a7c3.png";